export const ALGORITHMS = [
    'Array',
    'String',
    'Linked List',
    'Stack',
    'Queue',
    'Tree',
    'Graph',
    'DP',
    'Greedy',
    'Backtracking',
    'Binary Search',
    'Sorting',
    'Hashing',
    'Math',
    'Bit Manipulation',
    'Heap',
    'Trie',
    'Sliding Window',
    'Two Pointers'
  ];
  
  export const PLATFORMS = [
    'LeetCode',
    'HackerRank',
    'CodeChef',
    'Codeforces',
    'GeeksforGeeks',
    'InterviewBit',
    'AtCoder',
    'TopCoder'
  ];
  
  export const INITIAL_FORM_DATA = {
    title: '',
    difficulty: 'Medium',
    algorithm: '',
    solution: '',
    notes: '',
    platform: 'LeetCode',
    problemUrl: '',
    timeComplexity: '',
    spaceComplexity: '',
    timeTaken: '',
    starred: false
  };